import { useState } from 'react';
import { LEAGUE } from '@ff/core';
import { signInWithGoogle } from '../lib/firebase.ts';

export function Login() {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handle() {
    setBusy(true);
    setError(null);
    try {
      await signInWithGoogle();
    } catch {
      setError('Could not sign in. Try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center px-6">
      <div className="w-full max-w-sm text-center">
        <p className="eyebrow">{LEAGUE.name}</p>
        <h1 className="mt-3 font-display text-5xl font-black uppercase leading-none tracking-tight">
          {LEAGUE.bookName}
        </h1>
        <p className="mt-4 text-sm text-chalk-dim">
          The league ledger. Members only. Sign in with the Google account your
          buddies know you by.
        </p>

        <button
          onClick={handle}
          disabled={busy}
          className="mt-8 w-full rounded-md bg-chalk px-4 py-3 font-display font-bold uppercase tracking-wide text-felt transition-opacity hover:opacity-90 disabled:opacity-50"
        >
          {busy ? 'Signing in…' : 'Sign in with Google'}
        </button>

        {error && <p className="mt-4 text-sm text-blood">{error}</p>}

        <p className="mt-6 font-mono text-[0.7rem] text-chalk-dim">
          Not on the list? Ask the commissioner to add you.
        </p>
      </div>
    </div>
  );
}
